// @ts-nocheck
class WIproductcard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.proCardSplide();
    this.hideInfo();
  }

  // product card splide
  proCardSplide() {
    const proThis = this;
    document.addEventListener("DOMContentLoaded", function () {
      // Product card splide
      let splideImage = proThis.querySelector(".WI_proCard_image_splide");
      let WI_productCard_splide = new Splide(splideImage, {
        perPage: 1,
        perMove: 1,
        pagination: false,
        arrows: false,
        easing: "ease-out",
         padding: {
            right: '0', // Or a smaller value
            left: '0',
        }
      });
      var bar = WI_productCard_splide.root.querySelector(
        ".WI_proCard_image_progressbar"
      );
      // Updates the bar width whenever the carousel moves:
      WI_productCard_splide.on("mounted move", function () {
        var end = WI_productCard_splide.Components.Controller.getEnd() + 1;
        var rate = Math.min((WI_productCard_splide.index + 1) / end, 1);
        bar.style.width = String(100 * rate) + "%";
      });
      WI_productCard_splide.mount();
      // Custom button events
      splideImage
        .querySelector(".WI_custom_prev")
        .addEventListener("click", () => {
          WI_productCard_splide.go("<"); // Go to previous
        });

      splideImage
        .querySelector(".WI_custom_next")
        .addEventListener("click", () => {
          WI_productCard_splide.go(">"); // Go to next
        });
    });

    document.addEventListener("imgLoad", () => {
      // Product card splide
      let splideImage = proThis.querySelector(".WI_proCard_image_splide");
      let WI_productCard_splide = new Splide(splideImage, {
        perPage: 1,
        perMove: 1,
        type: "fade",
        pagination: false,
        arrows: false,
        easing: "ease-out",
         padding: {
            right: '0', // Or a smaller value
            left: '0',
        }
      });
      var bar = WI_productCard_splide.root.querySelector(
        ".WI_proCard_image_progressbar"
      );
      // Updates the bar width whenever the carousel moves:
      WI_productCard_splide.on("mounted move", function () {
        var end = WI_productCard_splide.Components.Controller.getEnd() + 1;
        var rate = Math.min((WI_productCard_splide.index + 1) / end, 1);
        bar.style.width = String(100 * rate) + "%";
      });
      WI_productCard_splide.mount();
      // Custom button events
      splideImage
        .querySelector(".WI_custom_prev")
        .addEventListener("click", () => {
          WI_productCard_splide.go("<"); // Go to previous
        });

      splideImage
        .querySelector(".WI_custom_next")
        .addEventListener("click", () => {
          WI_productCard_splide.go(">"); // Go to next
        });
    });
  }

  // hide product card info for 8 grid view and handle promo card positioning
  hideInfo() {
    document.addEventListener("eight:grid", () => {
      document
        .querySelector("#WI_mainCollection_grpGrid")
        .classList.add("WI_productCard_in_info_remove");
        document
        .querySelector("#WI_mainCollection_grpGrid")
        .classList.remove("WI_productCard_in_info_4remove");
      this.updatePromoCardClasses(8);
    });
    document.addEventListener("four:grid", () => {
      document
        .querySelector("#WI_mainCollection_grpGrid")
        .classList.add("WI_productCard_in_info_4remove");
        document
        .querySelector("#WI_mainCollection_grpGrid")
        .classList.remove("WI_productCard_in_info_remove");
      this.updatePromoCardClasses(4);
    });
    document.addEventListener("noeight:grid", () => {
      document
        .querySelector("#WI_mainCollection_grpGrid")
        .classList.remove("WI_productCard_in_info_remove");
      document
        .querySelector("#WI_mainCollection_grpGrid")
        .classList.remove("WI_productCard_in_info_4remove");
      // Get current view number from active button
      const activeButton = document.querySelector(
        ".GridViewBtn[style*='underline']"
      );
      if (activeButton) {
        const viewNum = parseInt(activeButton.getAttribute("data-num"));
        this.updatePromoCardClasses(viewNum);
      }
    });

    // Handle promo card positioning based on view selection
    this.positionPromoCard();
  }

  // Position promo card based on current view
  positionPromoCard() {
    // Listen for view changes
    document.addEventListener("click", (e) => {
      if (e.target?.classList.contains("GridViewBtn")) {
        const viewNum = parseInt(e.target.getAttribute("data-num"));
        this.updatePromoCardClasses(viewNum);
      }
    });

    // Set initial position based on default view
    // Wait for DOM to be ready before applying classes
    const initPosition = () => {
      const width = window.innerWidth;
      // Mobile (<768px): default view 2, iPad (768-1024px): default view 4, Desktop (>1024px): default view 4
      const defaultView = width < 768 ? 2 : 4;
      this.updatePromoCardClasses(defaultView);
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initPosition);
    } else {
      initPosition();
    }
  }

  // Update promo card classes based on view number
  updatePromoCardClasses(viewNum) {
    // Clear any existing timeout
    if (this.promoCardTimeout) {
      clearTimeout(this.promoCardTimeout);
    }

    // Debounce the function call
    this.promoCardTimeout = setTimeout(() => {
      const promoCard = document.querySelector(".WI_promoCard");

      if (!promoCard) {
        return;
      }

      // Check if we already have the correct class
      const hasCorrectClass =
        ((viewNum === 8 || viewNum === 1) &&
          promoCard.classList.contains("WI_promoCard--hidden")) ||
        (viewNum === 4 &&
          promoCard.classList.contains("WI_promoCard--view4")) ||
        (viewNum === 2 &&
          promoCard.classList.contains("WI_promoCard--view2"));

      if (hasCorrectClass) {
        return;
      }

      // Remove all view-specific classes
      promoCard.classList.remove(
        "WI_promoCard--hidden",
        "WI_promoCard--view4",
        "WI_promoCard--view2"
      );

      // Add appropriate class based on view
      if (viewNum === 8 || viewNum === 1) {
        promoCard.classList.add("WI_promoCard--hidden");
      } else if (viewNum === 4) {
        promoCard.classList.add("WI_promoCard--view4");
      } else if (viewNum === 2) {
        promoCard.classList.add("WI_promoCard--view2");
      }
    }, 100);
  }

  // Move promo card to specific position in the grid
  movePromoCardToPosition(targetPosition) {
    const grid = document.querySelector("#WI_mainCollection_grpGrid");
    const promoCard = document.querySelector(".WI_promoCard");

    if (!grid || !promoCard) return;

    // Remove promo card from current position
    promoCard.remove();

    // Find all non-promo items
    const gridItems = grid.querySelectorAll("li:not(.WI_promoCard)");

    if (gridItems[targetPosition]) {
      // Insert after the target position
      gridItems[targetPosition].insertAdjacentElement("afterend", promoCard);
    } else {
      // If target position doesn't exist, append to end
      grid.appendChild(promoCard);
    }
  }
}
customElements.define("wi-productcard", WIproductcard);
